<template>
    <div class="modal-dialog">
        <div class="modal-content height-20-em">
            <div v-if="!alreadychangpass" class="bg-light border-bottom-0 modal-header">
                <h5 class="modal-title">
                    {{$t("Forgot Password")}}
                </h5>
                <button
                    type="button"
                    class="close"
                    ref="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div v-if="!alreadychangpass" class="pt-0 mt-3">
                    <div class="row col-md-12">
                        <label>{{$t('Your Email')}}</label>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group form-group-feedback">
                                <input type="email" :placeholder="$t('Enter your email...')" id="" class="form-control" v-model="sendEmail">
                                <label class="validation-invalid-label" for="variationInfo_code" v-if="message != ''">{{ $t(message) }}</label>
                                <label class="validation-invalid-label" for="variationInfo_code" v-if="!validEmptyEmail">{{ $t("Please enter your email.") }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mt-3 mb-0">
                        <div class="text-center">
                            <button @click="goChangePassword" class="btn btn-primary mr-2 btn-ladda btn-ladda-spinner ladda-button" type="button" :class="[loading ? 'disabled' : '']">
                            <i :class="[loading ? 'icon-spinner2 spinner' : 'fa-solid fa-circle-check','mr-1',]"></i>
                            {{ $t("Reset Password") }}
                            </button>
                            <!-- <button type="button" class="btn btn-primary mr-2" @click="goChangePassword"><i class="fa-solid fa-lock-keyhole mr-1"></i> {{$t('Reset Password')}}</button> -->
                            <button type="button" class="btn btn-light" @click="goChangeEmail">{{$t('Cancel')}}</button>
                        </div>
                    </div>
                </div>
                <div v-if="alreadychangpass" class="content pt-5">
                    <div class="text-center mb-3">
                        <img alt="" width="160" :src="$storeIndex.getImageGobalAssets('Frame')" >
                        <h4 class="mt-1 mb-0">{{$t('Session Invalid')}}</h4>
                        <h6>{{$t('You will be logged out in')+' '+resendDelay+' '+$t('second')}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CentralApi from '@/services/endpoint/central.service'
import Ladda from '@/plugins/Ladda.vue'
import Api from '@/services/endpoint/tenant.service'


export default {
    name: 'modal_forgot',
    components: {
        Ladda
    },
    data() {
        return{
            alreadychangpass: false,
            sendEmail: '',
            resendDelay: 5,
            message:'',
            loading: false,
            validEmptyEmail: true,
        }
    },
    methods: {
        goChangeEmail(){
            this.$parent.showModalForgotPassword = false;
        },
        async goChangePassword(){
            this.validEmptyEmail = true;
            if(this.sendEmail != ''){
                let allow = await CentralApi.Auth.iswhitelistEmail(this.sendEmail);
                if(!allow.data.whitelist){
                    let notAllowed = await CentralApi.Auth.isblacklistEmail(this.sendEmail);
                    if(notAllowed.data.blacklist){
                        this.$toastr.Add({
                            type: "warning",
                            title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                            msg: this.$t("Email cannot be sent to")+" "+
                                this.sendEmail+" "+
                                this.$t("because this recipient is in blacklist.")+" "+
                                this.$t("If you feel this is a mistake, contact your admin."),
                            clickClose: true,
                            timeout: 5000,
                            position: "toast-top-right"
                        });
                        return false;
                    }
                }
                this.loading = true;
                let params = {
                    email: this.sendEmail
                };
                try {
                    const res = await CentralApi.Auth.forgotPassword(params);
                    if (!res.data.forgotpassword) {
                        this.message = 'This email does not exist in the system.';
                    } else {
                        $('#ModalChangeEmail').modal('hide');
                        $('#ModalChangePhone').modal('hide');
                        this.$toastr.s(
                            this.$t("Send Email Success"),
                            "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success")
                        );
                    }
                    this.loading = false;
                    return true;
                } catch (error) {
                    this.loading = false;
                    let message = error.response.data.message;
                    if(message == "This email is blacklisted.") {
                        message = this.$t("Email cannot be sent to")+" "+
                                this.sendEmail+" "+
                                this.$t("because this recipient is in blacklist.")+" "+
                                this.$t("If you feel this is a mistake, contact your admin.");
                    }
                    this.$toastr.Add({
                        type: "warning",
                        title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                        msg: message,
                        clickClose: true,
                        timeout: 5000,
                        position: "toast-top-right"
                    });
                    return false;
                }
            }else{
                this.validEmptyEmail = false;
            }
        },

    }
}
</script>
<style scoped>
    .height-20-em{
        min-height: 20em;
    }
</style>



// WEBPACK FOOTER //
// src/components/central/account/profile/ModalForgot.vue